import React from "react";
import { ButtonStyle } from "../styles/Button";
import PropTypes from "prop-types";

const Button = ({ children, ...attrs }) => {
  return <ButtonStyle {...attrs}>{children}</ButtonStyle>;
};

Button.propTypes = {
  children: PropTypes.node,
};

export default Button;
